var _style, _g, _g2, _path, _g3, _g4, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnakinLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0asl{fill:#588443;}\r\n\t.st1asl{fill:#663722;}\r\n\t.st2asl{fill:#FAC8AA;}\r\n\t.st3asl{fill:#F9C2A0;}\r\n\t.st4asl{fill:#703E23;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lag_1_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0asl",
    cx: 150,
    cy: 150.3,
    r: 150
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_2_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1asl",
    d: "M91.2,268.2h-2.4c-1.4,0-2.6-1.2-2.6-2.6V160.3c0-1.4,1.2-2.6,2.6-2.6h2.4c1.4,0,2.6,1.2,2.6,2.6v105.3 C93.8,267,92.6,268.2,91.2,268.2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2asl",
    d: "M154.8,259.8c-0.6,0.1-1.2,0.2-1.8,0.2c-1.1,0.1-2.1,0.2-3.1,0.2c-1.2-0.1-2.4-0.3-3.7-0.6 c-1-0.2-2-0.4-2.9-0.6c-0.1-51.3-0.2-102.5-0.2-153.8H159C157.6,156.7,156.2,208.3,154.8,259.8z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2asl",
    d: "M93.6,82.1c-10.1,22.6-20.2,45.3-30.3,67.9c-1.8,6.5-6.8,27,4.3,39.7c0.8,0.9,1.8,1.9,2.8,2.7 c2.5,0.7,5,1.3,7.5,2c6.6,12.1,13.2,21.4,18.2,27.8c11.8,15,22.5,28.5,40.7,34.9c5.4,1.9,10.2,2.7,13.2,3.1 c0.4-60.1,0.8-120.2,1.2-180.4c-9.8,0.3-19.6,0.7-29.4,1.1C112.4,81.3,103,81.7,93.6,82.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3asl",
    d: "M235.9,149.2c-11.7-23.8-23.3-47.6-35-71.4c-17,0.7-33.9,1.4-50.9,2c0,60.1,0,120.3,0,180.4 c2.6-0.1,6.5-0.5,11-1.6c18.6-4.7,29.9-18.3,41.4-32.5c5.6-6.9,12.9-17,19.8-30.2c3.5-0.5,6.1-1.8,7.9-3.1 C239.9,185.9,242.1,168.5,235.9,149.2z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4asl",
    d: "M88.2,185.2c2.4-0.7-2-14-0.2-37.9c0.8-10.1,2.3-18.4,3.7-24.2c4.9-1.8,10-3.4,15.5-4.8 c32-8.2,61.1-5.1,82.1-0.2c1.9,1.2,5.1,3.4,7.8,7.3c3.3,4.9,4.1,9.7,4.3,12c0.8-1.5,2.3-4.5,2.3-8.7c0.1-3.9-1.1-6.9-1.8-8.3 c2.2,3.5,3.7,6.4,4.6,8.4c11.8,24.7,7.7,50.6,5.5,57.8c-0.2,0.5-0.5,1.5-0.3,1.6c0.6,0.3,10.2-16.2,16.3-34.9 c2.5-7.6,5.2-18.1,6.5-31.2c0.6-7.5,0.7-17.3-1.5-28.5c-1.3-6.8-3.2-12.8-5.1-17.8c-2.8-6.5-5.6-13-8.4-19.4 c-1.6-2.9-5.4-9-12.8-13.7c-7.5-4.8-14.8-5.6-18.1-5.8c0-0.2-0.1-0.9,0.4-1.6c0.6-0.8,1.5-0.9,1.7-0.9c-0.5-0.2-1.2-0.3-1.9-0.3 c-1.9-0.2-3.5,0.3-4.5,0.7c-0.9,0-1.9,0-2.8,0c0-1.1,0-2.4,0.3-3.9c0.5-2.3,1.3-4,1.9-5.3c-1.1,0.6-2.9,1.8-4.5,3.8s-2.3,4-2.6,5.2 c-0.4,0-0.8,0-1.2,0c0.1-1.8,0.4-4.3,1.3-7c1.1-3.4,2.7-5.9,3.9-7.6c-1.1,0.4-2.3,0.9-3.5,1.6c-6.1,3.5-9,9.2-10.3,12.2 c-15.8-2.2-40-3-65.5,7.7c-5.1,2.1-9.8,4.5-14,7C85,48.9,80.9,50,77,53.3c-2.1,1.7-3.5,3.5-4.5,5c1-0.7,2.9-2,5.7-2.3 c1.5-0.2,2.7-0.1,3.6,0.1c-1.8,1.1-4.9,3.3-7.5,7.1c-2.5,3.6-3.4,7.1-3.8,9.1c0.7-1,1.8-2.4,3.6-3.7c1.1-0.8,2.2-1.3,3.1-1.6 c-6.2,13.2-14.5,36-11.4,63.5C69,161.1,84.8,186.3,88.2,185.2z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0asl",
    d: "M150,260.2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnakinLogo);
export default __webpack_public_path__ + "static/media/anakin-logo.a18cf96e.svg";
export { ForwardRef as ReactComponent };